module.exports = __webpack_public_path__ + "static/media/SLV.4a1fa1b2.svg";